// extracted by mini-css-extract-plugin
var _1 = "container--uJrWWeZk";
var _2 = "text--TBSvXRmv";
export { _1 as "container", _2 as "text" }
